import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: '/',
      component: () => import('@P/complaint'),
      meta: {
        ifTitle: true,
        titleEnglish: 'Complaint Form in relation to Banking Products and Services',
        titleComplex: '有關銀行產品或服務的投訴表格',
        titleSimple: '有关银行产品或服务的投诉表格'
      },
    },
    {
      path: '/complaint',
      name: 'complaint',
      component: () => import('@P/complaint'),
      meta: {
        ifTitle: true,
        titleEnglish: 'Complaint Form in relation to Banking Products and Services',
        titleComplex: '有關銀行產品或服務的投訴表格',
        titleSimple: '有关银行产品或服务的投诉表格'
      },
    },
    {
      path: '/note',
      name: 'note',
      component: () => import('@P/note'),
      meta: {
        ifTitle: true,
        titleEnglish: 'Notes for Complainant',
        titleComplex: '投訴人須知',
        titleSimple: '投诉人须知'
      },
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@P/home'),
      meta: {
        ifTitle: true,
        titleEnglish: 'Consent to Disclose Your Information and Personal Data',
        titleComplex: '披露個案及個人資料的同意書',
        titleSimple: '披露个案及个人资料的同意书'
      },
    },
    {
      path: '/part1',
      name: 'part1',
      component: () => import('@P/part1'),
      meta: {}
    },
    {
      path: '/part2',
      name: 'part2',
      component: () => import('@P/part2'),
      meta: {}
    },
    {
      path: '/part3',
      name: 'part3',
      component: () => import('@P/part3'),
      meta: {}
    },
    {
      path: '/part4',
      name: 'part4',
      component: () => import('@P/part4'),
      meta: {}
    },
    {
      path: '/preview',
      name: 'preview',
      component: () => import('@P/preview'),
      meta: {}
    },
    {
      path: '/submit',
      name: 'submit',
      component: () => import('@P/submit'),
      meta: {}
    },
    {
      path: '/wrongPage',
      name: 'wrongPage',
      component: () => import('@P/wrongPage'),
      meta: {}
    },
  ],
  
})

export default router;
router.beforeEach((to, from, next) => {
  console.log('------------');
  console.log(to);
  
  if (to.matched.length == 0) { 
    next({path:'/wrongPage'}); 
  } else {
    next(); //如果匹配到正确跳转
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js